import api from './api';
import { AppUser } from '../contexts/AuthContext';

type LoginResult = {
  accessToken: string;
  user: AppUser;
};

type RegisterResult = {
  accessToken: string | null;
  user: AppUser;
  pendingApproval?: boolean;
};

export async function exchangeFirebaseToken(
  idToken: string,
): Promise<LoginResult> {
  const { data } = await api.post('/auth/login', { idToken });
  return data;
}

export async function registerWithFirebaseToken(
  idToken: string,
  options?: {
    accountType?: 'comercial_produtos' | 'comercial_servicos';
    name?: string;
  },
): Promise<RegisterResult> {
  const { data } = await api.post('/auth/register', {
    idToken,
    accountType: options?.accountType,
    name: options?.name,
  });
  return data;
}

export async function logoutSession(): Promise<void> {
  try {
    await api.post('/auth/logout');
  } catch {
    // Sessão local ainda deve ser limpa mesmo se a API falhar.
  }
}
